export const InputModalConstants = {
  tooltip: {
    background: "#00325A",
    radius: 20,
    padding: 10,
    placement: "right",
    fontSize: "12px",
  },
};
